import { render, staticRenderFns } from "./ConsignmentAgreement.vue?vue&type=template&id=49ca852c&scoped=true&"
import script from "./ConsignmentAgreement.vue?vue&type=script&lang=js&"
export * from "./ConsignmentAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ConsignmentAgreement.vue?vue&type=style&index=0&id=49ca852c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ca852c",
  null
  
)

export default component.exports